export default {
  updateDocuments(state, data) {
    state.documents = data;
  },
}
